import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

const CommentCardActions = ({ isOwner, resolved, onResolve, onEdit, onDelete }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flexShrink: 0 }}>
      <Tooltip title={resolved ? t('tooltip_reopen') : t('tooltip_resolve')}>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onResolve(!resolved);
          }}
          sx={{
            p: 0.5,
            color: resolved ? 'primary.main' : 'action.active',
            '&:hover': {
              color: 'primary.main',
              bgcolor: 'primary.50',
            },
          }}
        >
          {resolved ? (
            <CheckCircleIcon sx={{ fontSize: 16 }} />
          ) : (
            <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Tooltip>

      {isOwner && (
        <>
          <Tooltip title={t('tooltip_edit')}>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
              sx={{
                p: 0.5,
                color: 'action.active',
                '&:hover': {
                  color: 'text.primary',
                  bgcolor: 'action.hover',
                },
              }}
            >
              <EditIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>

          <Tooltip title={t('tooltip_delete')}>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              sx={{
                p: 0.5,
                color: 'action.active',
                '&:hover': {
                  color: 'error.main',
                  bgcolor: 'error.50',
                },
              }}
            >
              <DeleteIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </>
      )}
    </Box>
  );
};

export default CommentCardActions;
